import { gql, useQuery } from '@apollo/client'

import {
  MissionAccomplishedQuery,
  MissionAccomplishedQueryVariables,
  MissionRewardConnectionFragmentDoc,
} from '@/clients/utoniq-core/schema'
import { config } from '@/config'
import { useRouter } from '@/core'
import { makeViewModel } from '@/core/architecture'

import { Action, State } from './template'

export const useViewModel = makeViewModel<State, Action>(() => {
  const { router } = useRouter<{ missionId: string; artistId?: string }>()
  const { data } = useQuery<
    MissionAccomplishedQuery,
    MissionAccomplishedQueryVariables
  >(QUERY, {
    variables: { missionId: router.query.missionId },
  })

  return {
    state: {
      isFromArtistMission:
        !!router.query.artistId || config.applicationType === 'standalone',
      mission: data?.mission ?? null,
    },
    actions: {},
  }
})

const QUERY = gql`
  query MissionAccomplished($missionId: ID!) {
    mission(id: $missionId) {
      id
      ...MissionRewardConnection
    }
  }
  ${MissionRewardConnectionFragmentDoc}
`
